import React from "react";
import axios from "axios";
import { toast } from "sonner";

const API = process.env.REACT_APP_BACKEND_URL + "/api";

export function NotifyBack({ productId, testidPrefix = "notify" }) {
  const [open, setOpen] = React.useState(false);
  const [email, setEmail] = React.useState("");
  const [sent, setSent] = React.useState(false);
  const [busy, setBusy] = React.useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email.includes("@")) return;
    setBusy(true);
    try {
      await axios.post(`${API}/stock-notify`, { product_id: productId, email });
      setSent(true);
      toast.success("We'll email you when it's back in stock");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Couldn't sign you up — please try again");
    } finally {
      setBusy(false);
    }
  };

  if (sent) {
    return (
      <p className="mt-2 text-[11px] text-emerald-600" data-testid={`${testidPrefix}-sent-${productId}`}>
        ✓ We&apos;ll email you when it&apos;s back
      </p>
    );
  }

  if (!open) {
    return (
      <button
        type="button"
        onClick={() => setOpen(true)}
        data-testid={`${testidPrefix}-open-${productId}`}
        className="mt-2 text-[11px] uppercase tracking-[0.2em] text-neutral-500 underline underline-offset-4 transition-colors hover:text-neutral-900"
      >
        Notify me when back
      </button>
    );
  }

  return (
    <form onSubmit={submit} className="mt-2 flex gap-2">
      <input
        type="email"
        required
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="your@email.com"
        data-testid={`${testidPrefix}-email-${productId}`}
        className="h-8 flex-1 rounded-full border border-neutral-300 px-3 text-xs outline-none focus:border-neutral-900"
      />
      <button
        type="submit"
        disabled={busy}
        data-testid={`${testidPrefix}-submit-${productId}`}
        className="h-8 rounded-full bg-black px-4 text-[10px] font-medium uppercase tracking-[0.15em] text-white disabled:bg-neutral-300"
      >
        {busy ? "…" : "Notify"}
      </button>
    </form>
  );
}
